import { ColDef } from 'ag-grid-community';
import { DefaultCellTooltip } from 'components/grids/tooltip/DefaultCellTooltip';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useKFrgnCurPaymentDetailAdColDefs = () => {
  const { t } = useTranslation();
  const defaultColDef4 = useMemo((): ColDef => {
    return {
      sortable: true, // 요구사항8번 sortable: true로 변경하면 됨
      resizable: true,
      cellStyle: { textAlign: 'center' },
      tooltipComponent: DefaultCellTooltip,
    };
  }, []);

  const colDefs4: any = [
    {
      headerName: t('com.label.00122', '__전표번호'),
      headerTooltip: t('com.label.00122', '__전표번호'),
      field: 'slipNo',
      tooltipField: 'slipNo',
      flex: 1,
    },
    {
      headerName: t('com.label.00123', '__증빙일자'),
      headerTooltip: t('com.label.00123', '__증빙일자'),
      field: 'prfDt',
      tooltipField: 'prfDt',
      flex: 1,
    },
    {
      headerName: t('com.label.00125', '__담당부서'),
      headerTooltip: t('com.label.00125', '__담당부서'),
      field: 'mgrDeptNm',
      tooltipField: 'mgrDeptNm',
      cellStyle: { textAlign: 'left' },
      flex: 1,
    },
    {
      headerName: t('com.label.00127', '__구매오더'),
      headerTooltip: t('com.label.00127', '__구매오더'),
      field: 'purcOrd',
      tooltipField: 'purcOrd',
      flex: 1,
    },
    {
      headerName: t('com.label.00131', '__수입의뢰번호 '),
      headerTooltip: t('com.label.00131', '__수입의뢰번호 '),
      field: 'impReqNo',
      tooltipField: 'impReqNo',
      flex: 1,
    },
  ];

  const handleAprvDetailBtn = (data) => {
    console.log('화면 연결이 필요합니다.');
  };

  return { defaultColDef4, colDefs4 };
};
